"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSapphirePoolFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockSapphirePoolFactory = /** @class */ (function (_super) {
    __extends(MockSapphirePoolFactory, _super);
    function MockSapphirePoolFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockSapphirePoolFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockSapphirePoolFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockSapphirePoolFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockSapphirePoolFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockSapphirePoolFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockSapphirePoolFactory;
}(contracts_1.ContractFactory));
exports.MockSapphirePoolFactory = MockSapphirePoolFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_core",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_limit",
                type: "uint256",
            },
        ],
        name: "CoreBorrowLimitSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_limit",
                type: "uint256",
            },
        ],
        name: "DepositLimitSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_core",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amountDecreased",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_newStablesLentAmount",
                type: "uint256",
            },
        ],
        name: "StablesLentDecreased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_core",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_stablecoin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_borrowedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
        ],
        name: "TokensBorrowed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_depositAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_lpTokensAmount",
                type: "uint256",
            },
        ],
        name: "TokensDeposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_core",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_stablecoin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_repaidAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_debtRepaid",
                type: "uint256",
            },
        ],
        name: "TokensRepaid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_lpAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_withdrawAmount",
                type: "uint256",
            },
        ],
        name: "TokensWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accumulatedRewardAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenAddress",
                type: "address",
            },
        ],
        name: "assetDepositUtilization",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amountUsed",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "limit",
                        type: "uint256",
                    },
                ],
                internalType: "struct SharedPoolStructs.AssetUtilization",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stablecoinAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_scaledBorrowAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
        ],
        name: "borrow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_coreAddress",
                type: "address",
            },
        ],
        name: "coreBorrowUtilization",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amountUsed",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "limit",
                        type: "uint256",
                    },
                ],
                internalType: "struct SharedPoolStructs.AssetUtilization",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_debtDecreaseAmount",
                type: "uint256",
            },
        ],
        name: "decreaseStablesLent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_userAddress",
                type: "address",
            },
        ],
        name: "deposits",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getActiveCores",
        outputs: [
            {
                internalType: "address[]",
                name: "_activeCores",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getDepositAssets",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getPoolValue",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_decimalsIn",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "_decimalsOut",
                type: "uint8",
            },
        ],
        name: "getScaledAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_coreAddress",
                type: "address",
            },
        ],
        name: "removeActiveCore",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stablecoinAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_repayAmount",
                type: "uint256",
            },
        ],
        name: "repay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_coreAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_limit",
                type: "uint256",
            },
        ],
        name: "setCoreBorrowLimit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_limit",
                type: "uint256",
            },
        ],
        name: "setDepositLimit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stablesLent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "tokenDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lpAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_withdrawToken",
                type: "address",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506001600a556132e5806100256000396000f3fe608060405234801561001057600080fd5b50600436106102055760003560e01c80636e9960c31161011a57806395d89b41116100ad578063d0042e131161007c578063d0042e131461051b578063d505accf14610524578063dd62ed3e14610537578063fc43863f14610570578063fc7e286d1461057857600080fd5b806395d89b41146104da578063a591e541146104e2578063a9059cbb146104f5578063cfa4d3f11461050857600080fd5b80637ecebe00116100e95780637ecebe00146104265780638ee573ac14610446578063909834b2146104725780639539c312146104c757600080fd5b80636e9960c3146103b55780637029144c146103d5578063707ef3e2146103e857806370a08231146103fd57600080fd5b8063272d177d1161019d57806347e7ef241161016c57806347e7ef241461030f57806350c62e5e1461032257806354fd4d501461032a578063590579a2146103325780636c665a55146103a257600080fd5b8063272d177d146102b357806330adf81f146102c6578063313ce567146102ed5780633644e5151461030657600080fd5b806318160ddd116101d957806318160ddd146102735780631ba2f5311461028557806322867d781461028d57806323b872dd146102a057600080fd5b8062f714ce1461020a57806306fdde031461021f578063095ea7b31461023d57806317f1053514610260575b600080fd5b61021d610218366004612e00565b6105a1565b005b6102276106e4565b6040516102349190612ee8565b60405180910390f35b61025061024b366004612ceb565b610776565b6040519015158152602001610234565b61021d61026e366004612bf8565b61078d565b6007545b604051908152602001610234565b61027761090f565b61021d61029b366004612ceb565b610a20565b6102506102ae366004612c44565b610ad6565b61021d6102c1366004612ceb565b610b29565b6102777f6e71edae12b1b97f4d1f60370fef10105fa2faae0126114a169c64845d6126c981565b60065460ff165b60405160ff9091168152602001610234565b61027760025481565b61021d61031d366004612ceb565b610ea3565b610277611073565b610227611127565b610387610340366004612bf8565b6040805180820190915260008082526020820152506001600160a01b03166000908152600e6020908152604091829020825180840190935280548352600101549082015290565b60408051825181526020928301519281019290925201610234565b61021d6103b0366004612d14565b6111b5565b6103bd61126d565b6040516001600160a01b039091168152602001610234565b61021d6103e3366004612d6f565b61129c565b6103f061134e565b6040516102349190612e9b565b61027761040b366004612bf8565b6001600160a01b031660009081526004602052604090205490565b610277610434366004612bf8565b60036020526000908152604090205481565b6102f4610454366004612bf8565b6001600160a01b031660009081526011602052604090205460ff1690565b610387610480366004612bf8565b6040805180820190915260008082526020820152506001600160a01b03166000908152600d6020908152604091829020825180840190935280548352600101549082015290565b6102776104d5366004612e22565b6114f9565b61022761150e565b61021d6104f0366004612dd0565b61151d565b610250610503366004612ceb565b6115aa565b61021d610516366004612ceb565b6115b7565b610277600b5481565b61021d610532366004612c7f565b611743565b610277610545366004612c12565b6001600160a01b03918216600090815260056020908152604080832093909416825291909152205490565b6103f0611766565b610277610586366004612bf8565b6001600160a01b03166000908152600c602052604090205490565b806105c6816001600160a01b031660009081526011602052604090205460ff16151590565b6105eb5760405162461bcd60e51b81526004016105e290612fe2565b60405180910390fd5b6002600a54141561060e5760405162461bcd60e51b81526004016105e290613019565b6002600a55600080806106218686611916565b6001600160a01b0388166000908152600e6020526040812080549497509295509093508592610651908490613195565b9091555050336000908152600c602052604081208054849290610675908490613195565b9091555061068590503387611a00565b610690853383611af4565b60408051878152602081018390526001600160a01b0387169133917f6b83b455c317523498e4e86849438d4356ad79ba6b355a5e6d5bc05eca6c780f91015b60405180910390a350506001600a5550505050565b6060600880546106f3906131fb565b80601f016020809104026020016040519081016040528092919081815260200182805461071f906131fb565b801561076c5780601f106107415761010080835404028352916020019161076c565b820191906000526020600020905b81548152906001019060200180831161074f57829003601f168201915b5050505050905090565b6000610783338484611c0f565b5060015b92915050565b61079561126d565b6001600160a01b0316336001600160a01b0316146107c55760405162461bcd60e51b81526004016105e290612f5d565b60005b60105460ff8216101561090b57816001600160a01b031660108260ff168154811061080357634e487b7160e01b600052603260045260246000fd5b6000918252602090912001546001600160a01b031614156108f9576010805461082e90600190613195565b8154811061084c57634e487b7160e01b600052603260045260246000fd5b600091825260209091200154601080546001600160a01b039092169160ff841690811061088957634e487b7160e01b600052603260045260246000fd5b9060005260206000200160006101000a8154816001600160a01b0302191690836001600160a01b0316021790555060108054806108d657634e487b7160e01b600052603160045260246000fd5b600082815260209020810160001990810180546001600160a01b03191690550190555b8061090381613251565b9150506107c8565b5050565b60008060005b600f5460ff82161015610a12576000600f8260ff168154811061094857634e487b7160e01b600052603260045260246000fd5b6000918252602080832091909101546001600160a01b031680835260119091526040918290205491516370a0823160e01b815230600482015290925060ff909116906109f19083906370a082319060240160206040518083038186803b1580156109b157600080fd5b505afa1580156109c5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109e99190612de8565b826012611d34565b6109fb9085613050565b935050508080610a0a90613251565b915050610915565b50600b546107879082613050565b336000908152600d6020526040902060010154610a4f5760405162461bcd60e51b81526004016105e290612f1b565b6002600a541415610a725760405162461bcd60e51b81526004016105e290613019565b6002600a556000610a838383611d9e565b60408051848152602081018390529192506001600160a01b0385169133917fc7889932de29e885510a0b3221f457b8c692aa329d5e0bf9db2bb1026c288556910160405180910390a350506001600a5550565b6000610ae3848484611ee2565b6001600160a01b038416600090815260056020908152604080832033808552925290912054610b1e918691610b19908690613195565b611c0f565b5060015b9392505050565b610b3161126d565b6001600160a01b0316336001600160a01b031614610b615760405162461bcd60e51b81526004016105e290612f5d565b6001600160a01b03821660009081526011602052604090205460ff16151581151580610b8a5750805b610bfc5760405162461bcd60e51b815260206004820152603b60248201527f5361707068697265506f6f6c3a2063616e6e6f742073657420746865206c696d60448201527f6974206f6620616e20756e6b6e6f776e20617373657420746f2030000000000060648201526084016105e2565b600080610c0b60008087612050565b5091509150600084118015610c1e575082155b15610d0a57600f80546001810182556000919091527f8d1108e10bcb7c27dddfc02ed9d693a074039d026cf4ea4240b40f7d581ac8020180546001600160a01b0319166001600160a01b0387169081179091556040805163313ce56760e01b8152905163313ce56791600480820192602092909190829003018186803b158015610ca757600080fd5b505afa158015610cbb573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610cdf9190612e63565b6001600160a01b0386166000908152601160205260409020805460ff191660ff929092169190911790555b6001600160a01b038516600090815260116020526040812054600654610d3891879160ff9182169116611d34565b90506000610d468285613050565b11610dc35760405162461bcd60e51b815260206004820152604160248201527f5361707068697265506f6f6c3a206174206c656173742031206465706f73697460448201527f206173736574206d7573742068617665206120706f736974697665206c696d696064820152601d60fa1b608482015260a4016105e2565b81610dce8285613050565b1015610e44576040805162461bcd60e51b81526020600482015260248101919091527f5361707068697265506f6f6c3a2073756d206f6620626f72726f77206c696d6960448201527f747320657863656564732073756d206f66206465706f736974206c696d69747360648201526084016105e2565b6001600160a01b0386166000818152600e6020908152604091829020600101889055815192835282018790527fb5d5d4292fe8559d190a7787f1cad866d9c72449e7acfcf016622126dbad0287910160405180910390a1505050505050565b6002600a541415610ec65760405162461bcd60e51b81526004016105e290613019565b6002600a556001600160a01b0382166000908152600e6020526040902060018101548154610ef5908490613050565b1115610f5c5760405162461bcd60e51b815260206004820152603060248201527f5361707068697265506f6f6c3a2063616e6e6f74206465706f736974206d6f7260448201526f19481d1a185b881d1a19481b1a5b5a5d60821b60648201526084016105e2565b6001600160a01b038316600090815260116020526040812054600654610f8a91859160ff9182169116611d34565b90506000610f9661090f565b905060008115610fd957600654610fd290610fb59060ff16600a6130cb565b600754610fc29086613176565b610fcc9190613068565b836121d8565b9050610fdc565b50815b84846000016000828254610ff09190613050565b9091555050336000908152600c602052604081208054859290611014908490613050565b909155506110249050338261220e565b611030863330886122ea565b60408051868152602081018390526001600160a01b0388169133917f9d572f819ae4f4b4839dda54bcb4cc8d7c2f0a67807db864716b20eafb51535991016106cf565b60008061107e61090f565b90506000805b600f5460ff82161015611115576000600f8260ff16815481106110b757634e487b7160e01b600052603260045260246000fd5b60009182526020808320909101546001600160a01b0316808352600e82526040808420546011909352909220549192506110f59160ff166012611d34565b6110ff9084613050565b925050808061110d90613251565b915050611084565b506111208183613195565b9250505090565b60018054611134906131fb565b80601f0160208091040260200160405190810160405280929190818152602001828054611160906131fb565b80156111ad5780601f10611182576101008083540402835291602001916111ad565b820191906000526020600020905b81548152906001019060200180831161119057829003601f168201915b505050505081565b336000908152600d60205260409020600101546111e45760405162461bcd60e51b81526004016105e290612f1b565b6002600a5414156112075760405162461bcd60e51b81526004016105e290613019565b6002600a55600061121984848461240e565b604080518281526001600160a01b038581166020830152825193945087169233927f163295eda97d528a4f51907be7b0ca28a7139e787735ac076cec168f012dc83b928290030190a350506001600a555050565b60006112977fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035490565b919050565b6112a461126d565b6001600160a01b0316336001600160a01b0316146112d45760405162461bcd60e51b81526004016105e290612f5d565b600054610100900460ff16806112ed575060005460ff16155b6113095760405162461bcd60e51b81526004016105e290612f94565b600054610100900460ff1615801561132b576000805461ffff19166101011790555b61133783836012612542565b8015611349576000805461ff00191690555b505050565b60606000805b60105460ff821610156113d857600060108260ff168154811061138757634e487b7160e01b600052603260045260246000fd5b60009182526020808320909101546001600160a01b0316808352600d909152604090912060010154909150156113c557826113c181613251565b9350505b50806113d081613251565b915050611354565b508060ff1667ffffffffffffffff81111561140357634e487b7160e01b600052604160045260246000fd5b60405190808252806020026020018201604052801561142c578160200160208202803683370190505b5091506000805b60105460ff821610156114f357600060108260ff168154811061146657634e487b7160e01b600052603260045260246000fd5b60009182526020808320909101546001600160a01b0316808352600d909152604090912060010154909150156114e05780858460ff16815181106114ba57634e487b7160e01b600052603260045260246000fd5b6001600160a01b0390921660209283029190910190910152826114dc81613251565b9350505b50806114eb81613251565b915050611433565b50505090565b6000611506848484611d34565b949350505050565b6060600980546106f3906131fb565b336000908152600d602052604090206001015461154c5760405162461bcd60e51b81526004016105e290612f1b565b80600b600082825461155e9190613195565b9091555050600b5460405133917f14a166bdb4f7928a29a5405d7ee192c6a70877620d704500a69603849486938e9161159f91858252602082015260400190565b60405180910390a250565b6000610783338484611ee2565b6115bf61126d565b6001600160a01b0316336001600160a01b0316146115ef5760405162461bcd60e51b81526004016105e290612f5d565b600080600061160085866000612050565b91945092509050826116128584613050565b11156116945760405162461bcd60e51b8152602060048201526044602482018190527f5361707068697265506f6f6c3a2073756d206f6620746865206465706f736974908201527f206c696d69747320657863656564732073756d206f6620626f72726f77206c696064820152636d69747360e01b608482015260a4016105e2565b806116e557601080546001810182556000919091527f1b6847dc741a1b0cd08d278845f9d819d87b734759afb55fe2de5cb82a9ae6720180546001600160a01b0319166001600160a01b0387161790555b6001600160a01b0385166000818152600d6020908152604091829020600101879055815192835282018690527fba4364e1c443d62040bc4f3580a454c7019bf135e0752380f0130ef0c58c3114910160405180910390a15050505050565b6117528787878787878761260b565b61175d878787611c0f565b50505050505050565b60606000805b600f5460ff821610156117f0576000600f8260ff168154811061179f57634e487b7160e01b600052603260045260246000fd5b60009182526020808320909101546001600160a01b0316808352600e909152604090912060010154909150156117dd57826117d981613251565b9350505b50806117e881613251565b91505061176c565b5060008160ff1667ffffffffffffffff81111561181d57634e487b7160e01b600052604160045260246000fd5b604051908082528060200260200182016040528015611846578160200160208202803683370190505b5090506000805b600f5460ff8216101561190d576000600f8260ff168154811061188057634e487b7160e01b600052603260045260246000fd5b60009182526020808320909101546001600160a01b0316808352600e909152604090912060010154909150156118fa5780848460ff16815181106118d457634e487b7160e01b600052603260045260246000fd5b6001600160a01b0390921660209283029190910190910152826118f681613251565b9350505b508061190581613251565b91505061184d565b50909392505050565b6000806000806119268686612889565b6080810151909150156119eb578060600151816080015111156119785780604001518160a001511061195c578060400151611962565b8060a001515b81606001518260400151935093509350506119f9565b80608001518160c0015111156119d05760808101516006546001600160a01b0387166000908152601160205260409020546119ba929160ff9081169116611d34565b81608001518260400151935093509350506119f9565b8060a0015181608001518260400151935093509350506119f9565b604001516000935083925090505b9250925092565b6001600160a01b038216611a605760405162461bcd60e51b815260206004820152602160248201527f45524332303a206275726e2066726f6d20746865207a65726f206164647265736044820152607360f81b60648201526084016105e2565b6001600160a01b038216600090815260046020526040902054611a84908290613195565b6001600160a01b038316600090815260046020526040902055600754611aab908290613195565b6007556040518181526000906001600160a01b038416907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef906020015b60405180910390a35050565b604080516001600160a01b038481166024830152604480830185905283518084039091018152606490920183526020820180516001600160e01b031663a9059cbb60e01b1790529151600092839290871691611b509190612e7f565b6000604051808303816000865af19150503d8060008114611b8d576040519150601f19603f3d011682016040523d82523d6000602084013e611b92565b606091505b5091509150818015611bbc575080511580611bbc575080806020019051810190611bbc9190612d4f565b611c085760405162461bcd60e51b815260206004820152601a60248201527f5361666545524332303a205452414e534645525f4641494c454400000000000060448201526064016105e2565b5050505050565b6001600160a01b038316611c715760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b60648201526084016105e2565b6001600160a01b038216611cd25760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b60648201526084016105e2565b6001600160a01b0383811660008181526005602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92591015b60405180910390a3505050565b60008160ff168360ff161415611d4b575082610b22565b8160ff168360ff161115611d7f57611d6382846131ac565b611d6e90600a6130cb565b611d789085613068565b9050610b22565b611d8983836131ac565b611d9490600a6130cb565b611d789085613176565b6001600160a01b038216600090815260116020526040812054839060ff16611dd85760405162461bcd60e51b81526004016105e290612fe2565b6001600160a01b0384166000908152600e6020526040902060010154611e585760405162461bcd60e51b815260206004820152602f60248201527f5361707068697265506f6f6c3a2063616e6e6f7420726570617920776974682060448201526e3a34329033b4bb32b7103a37b5b2b760891b60648201526084016105e2565b6001600160a01b03841660009081526011602052604081205460065460ff9182169291611e89918791859116611d34565b336000908152600d6020526040812080549293509183918391611ead908490613195565b9250508190555081600b6000828254611ec69190613195565b90915550611ed89050873330896122ea565b5095945050505050565b6001600160a01b038316611f465760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b60648201526084016105e2565b6001600160a01b038216611fa85760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b60648201526084016105e2565b6001600160a01b038316600090815260046020526040902054611fcc908290613195565b6001600160a01b038085166000908152600460205260408082209390935590841681522054611ffc908290613050565b6001600160a01b0380841660008181526004602052604090819020939093559151908516907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef90611d279085815260200190565b60008060008060008060005b600f5460ff8216101561210e576000600f8260ff168154811061208f57634e487b7160e01b600052603260045260246000fd5b6000918252602090912001546001600160a01b03908116915089168114156120b757506120fc565b6001600160a01b0381166000908152600e60209081526040808320600101546011909252909120546120ee919060ff166012611d34565b6120f89086613050565b9450505b8061210681613251565b91505061205c565b5060005b60105460ff821610156121c857600060108260ff168154811061214557634e487b7160e01b600052603260045260246000fd5b6000918252602090912001546001600160a01b0390811691508b1681141561216c57600192505b896001600160a01b0316816001600160a01b0316141561218c57506121b6565b6001600160a01b0381166000908152600d60205260409020600101546121b29085613050565b9350505b806121c081613251565b915050612112565b5091989097509095509350505050565b6000816001816121f0670de0b6b3a764000087613176565b6121fa9190613050565b6122049190613195565b610b229190613068565b6001600160a01b0382166122645760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f20616464726573730060448201526064016105e2565b806007546122729190613050565b6007556001600160a01b038216600090815260046020526040902054612299908290613050565b6001600160a01b0383166000818152600460205260408082209390935591519091907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef90611ae89085815260200190565b604080516001600160a01b0385811660248301528481166044830152606480830185905283518084039091018152608490920183526020820180516001600160e01b03166323b872dd60e01b179052915160009283929088169161234e9190612e7f565b6000604051808303816000865af19150503d806000811461238b576040519150601f19603f3d011682016040523d82523d6000602084013e612390565b606091505b50915091508180156123ba5750805115806123ba5750808060200190518101906123ba9190612d4f565b6124065760405162461bcd60e51b815260206004820152601f60248201527f5361666545524332303a205452414e534645525f46524f4d5f4641494c45440060448201526064016105e2565b505050505050565b6001600160a01b038316600090815260116020526040812054849060ff166124485760405162461bcd60e51b81526004016105e290612fe2565b336000908152600d6020526040902060018101548154612469908790613050565b11156124c85760405162461bcd60e51b815260206004820152602860248201527f5361707068697265506f6f6c3a20636f726520626f72726f77206c696d697420604482015267195e18d95959195960c21b60648201526084016105e2565b6006546001600160a01b03871660009081526011602052604081205490916124f891889160ff9081169116611d34565b90508582600001600082825461250e9190613050565b9250508190555085600b60008282546125279190613050565b909155506125389050878683611af4565b9695505050505050565b600054610100900460ff168061255b575060005460ff16155b6125775760405162461bcd60e51b81526004016105e290612f94565b600054610100900460ff16158015612599576000805461ffff19166101011790555b6125bc84604051806040016040528060018152602001603160f81b8152506129ce565b83516125cf906008906020870190612ac1565b5082516125e3906009906020860190612ac1565b506006805460ff191660ff84161790558015612605576000805461ff00191690555b50505050565b8315806126185750428410155b6126645760405162461bcd60e51b815260206004820152601b60248201527f5065726d69747461626c653a205065726d69742065787069726564000000000060448201526064016105e2565b6001600160a01b0386166126c55760405162461bcd60e51b815260206004820152602260248201527f5065726d69747461626c653a207370656e6465722063616e6e6f742062652030604482015261078360f41b60648201526084016105e2565b6002546001600160a01b038816600090815260036020526040812080549192917f6e71edae12b1b97f4d1f60370fef10105fa2faae0126114a169c64845d6126c9918b918b918b91908761271883613236565b909155506040805160208101969096526001600160a01b0394851690860152929091166060840152608083015260a082015260c0810187905260e0016040516020818303038152906040528051906020012060405160200161279192919061190160f01b81526002810192909252602282015260420190565b60408051601f198184030181528282528051602091820120600080855291840180845281905260ff88169284019290925260608301869052608083018590529092509060019060a0016020604051602081039080840390855afa1580156127fc573d6000803e3d6000fd5b5050604051601f1901519150506001600160a01b038116158015906128325750806001600160a01b0316896001600160a01b0316145b61287e5760405162461bcd60e51b815260206004820152601e60248201527f5065726d69747461626c653a205369676e617475726520696e76616c6964000060448201526064016105e2565b505050505050505050565b6128c96040518060e00160405280600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081525090565b6129096040518060e00160405280600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081525090565b61291161090f565b81526007546020820181905281516129299086613176565b6129339190613068565b606082018190526006546001600160a01b038516600090815260116020526040902054612967929160ff9081169116611d34565b604080830191909152336000908152600c60209081528282205460808501526001600160a01b038616808352600e82528383205460a086018190529083526011909152919020546006546129c2929160ff9081169116611d34565b60c08201529392505050565b600054610100900460ff16806129e7575060005460ff16155b612a035760405162461bcd60e51b81526004016105e290612f94565b600054610100900460ff16158015612a25576000805461ffff19166101011790555b8151612a38906001906020850190612ac1565b508251602080850191909120835182850120604080517f8b73c3c69bb8fe3d512ecc4cf759cc79239f7b179b0ffacaa9a75d522b39400f818601528082019390935260608301919091524660808301523060a0808401919091528151808403909101815260c0909201905280519101206002558015611349576000805461ff0019169055505050565b828054612acd906131fb565b90600052602060002090601f016020900481019282612aef5760008555612b35565b82601f10612b0857805160ff1916838001178555612b35565b82800160010185558215612b35579182015b82811115612b35578251825591602001919060010190612b1a565b50612b41929150612b45565b5090565b5b80821115612b415760008155600101612b46565b80356001600160a01b038116811461129757600080fd5b600082601f830112612b81578081fd5b813567ffffffffffffffff80821115612b9c57612b9c613287565b604051601f8301601f19908116603f01168101908282118183101715612bc457612bc4613287565b81604052838152866020858801011115612bdc578485fd5b8360208701602083013792830160200193909352509392505050565b600060208284031215612c09578081fd5b610b2282612b5a565b60008060408385031215612c24578081fd5b612c2d83612b5a565b9150612c3b60208401612b5a565b90509250929050565b600080600060608486031215612c58578081fd5b612c6184612b5a565b9250612c6f60208501612b5a565b9150604084013590509250925092565b600080600080600080600060e0888a031215612c99578283fd5b612ca288612b5a565b9650612cb060208901612b5a565b955060408801359450606088013593506080880135612cce8161329d565b9699959850939692959460a0840135945060c09093013592915050565b60008060408385031215612cfd578182fd5b612d0683612b5a565b946020939093013593505050565b600080600060608486031215612d28578283fd5b612d3184612b5a565b925060208401359150612d4660408501612b5a565b90509250925092565b600060208284031215612d60578081fd5b81518015158114610b22578182fd5b60008060408385031215612d81578182fd5b823567ffffffffffffffff80821115612d98578384fd5b612da486838701612b71565b93506020850135915080821115612db9578283fd5b50612dc685828601612b71565b9150509250929050565b600060208284031215612de1578081fd5b5035919050565b600060208284031215612df9578081fd5b5051919050565b60008060408385031215612e12578182fd5b82359150612c3b60208401612b5a565b600080600060608486031215612e36578283fd5b833592506020840135612e488161329d565b91506040840135612e588161329d565b809150509250925092565b600060208284031215612e74578081fd5b8151610b228161329d565b60008251612e918184602087016131cf565b9190910192915050565b6020808252825182820181905260009190848201906040850190845b81811015612edc5783516001600160a01b031683529284019291840191600101612eb7565b50909695505050505050565b6020815260008251806020840152612f078160408501602087016131cf565b601f01601f19169190910160400192915050565b60208082526022908201527f5361707068697265506f6f6c3a2073656e646572206973206e6f74206120436f604082015261726560f01b606082015260800190565b6020808252601e908201527f41646d696e61626c653a2063616c6c6572206973206e6f742061646d696e0000604082015260600190565b6020808252602e908201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160408201526d191e481a5b9a5d1a585b1a5e995960921b606082015260800190565b6020808252601b908201527f5361707068697265506f6f6c3a20756e6b6e6f776e20746f6b656e0000000000604082015260600190565b6020808252601f908201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c00604082015260600190565b6000821982111561306357613063613271565b500190565b60008261308357634e487b7160e01b81526012600452602481fd5b500490565b600181815b808511156130c35781600019048211156130a9576130a9613271565b808516156130b657918102915b93841c939080029061308d565b509250929050565b6000610b2260ff8416836000826130e457506001610787565b816130f157506000610787565b816001811461310757600281146131115761312d565b6001915050610787565b60ff84111561312257613122613271565b50506001821b610787565b5060208310610133831016604e8410600b8410161715613150575081810a610787565b61315a8383613088565b806000190482111561316e5761316e613271565b029392505050565b600081600019048311821515161561319057613190613271565b500290565b6000828210156131a7576131a7613271565b500390565b600060ff821660ff8416808210156131c6576131c6613271565b90039392505050565b60005b838110156131ea5781810151838201526020016131d2565b838111156126055750506000910152565b600181811c9082168061320f57607f821691505b6020821081141561323057634e487b7160e01b600052602260045260246000fd5b50919050565b600060001982141561324a5761324a613271565b5060010190565b600060ff821660ff81141561326857613268613271565b60010192915050565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052604160045260246000fd5b60ff811681146132ac57600080fd5b5056fea2646970667358221220aa50a1d86c74fe4ac39bb86d4c851aade2a0ec989af1bab79a4dfb48a761b76d64736f6c63430008040033";
